import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import { connectRouter } from "connected-react-router";
import storage from "redux-persist/es/storage";

import SignupReducer from "../containers/SignUpContainer/reducer";
import LoginReducer from "../containers/LoginContainer/reducer";
import FeedbackReducer from "../containers/FeedbackContainer/reducer";
import ResetPwdReducer from "../containers/ForgotpasswordContainer/reducer";

import CategoryReducer from "../containers/CategoryContainer/reducer";
import UpdateProfileReducer from "../containers/UpdateProfileContainer/reducer";
import SupportReducer from "../containers/SupportContainer/reducer";

import DashboardReducer from "../containers/DashboardContainer/reducer";
import OrdersReducer from "../containers/OrdersContainer/reducer";
import NormalOrderReducer from "../containers/NormalOrdersContainer/reducer";
import store, { history } from "../boot/configureStore";
import MyProfileReducer from "../containers/MyProfileContainer/reducer";
import ProductReturnsReducer from "../containers/PurchaseReturnsContainer/reducer";
import ExpiryReturnsReducer from "../containers/ExpiryReturnsContainer/reducer";
import CreditNotesReducer from "../containers/CreditNotesContainer/reducer";
import PaymentReducer from "../containers/PaymentsContainer/reducer";
import InvoiceReducer from "../containers/InvoiceContainer/reducer";
import NotificationsReducer from "../containers/NotificationContainer/reducer";
import UsersReducer from "../containers/UsersContainer/reducer";

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),

    SignupReducer,
    FeedbackReducer,
    LoginReducer,
    MyProfileReducer,
    ResetPwdReducer,
    CategoryReducer,
    DashboardReducer,
    OrdersReducer,
    NormalOrderReducer,
    ProductReturnsReducer,
    ExpiryReturnsReducer,
    UpdateProfileReducer,
    SupportReducer,
    CreditNotesReducer,
    PaymentReducer,
    InvoiceReducer,
    NotificationsReducer,
    UsersReducer,
  });


export default createRootReducer;
